export default "__VITE_ASSET__Bn95E0PX__"